import * as helper from './helper';

export default class Imprint {
	constructor(nodeList) {
		for (let i = 0; i < nodeList.length; i++) {
			helper.addEventListener(nodeList[i], 'click', (evt) => {
				evt.preventDefault();

			});
		}
	}
}
